import React from "react";
import { Link, graphql } from "gatsby";

import Layout from "../components/layout";
import SEO from "../components/seo";

const RecruitsPage = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata.title;
  return (
    <Layout location={location} title={siteTitle}>
      <SEO title="해외송금 모인 개발 블로그" />
      채용 정보 페이지는 현재 준비중입니다.
      <h2>
        <Link to="https://www.rocketpunch.com/companies/moin/jobs">
          모인 채용 바로 가기
        </Link>
      </h2>
    </Layout>
  );
};

export default RecruitsPage;

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`;
